export default function auth({ next, router }) {
  const authToken =
    localStorage.getItem("asass_provider_dashboard_user_token") ||
    localStorage.getItem("bonian_provider_dashboard_user_token");

  if (!authToken) {
    return router.push("/");
  }
  return next();
}
